import React, { useCallback, useState } from 'react';
import Item from './Item';

const UnifiedReplacement = React.memo(({ replaceList, onCancel, onConfirm }) => {
  const handleConfirm = () => {
    if (canConfirm) {
      onConfirm();
    }
  };

  const canConfirm = replaceList.every((item) => item.imageList.every((image) => image[0]?.value?.url));

  return (
    <div className="w-[288px] px-3 pt-4 pb-3 text-white max-h-[400px] overflow-y-auto">
      <h1 className="text-sm font-medium">你可以替换图片后开始运行</h1>
      {replaceList.map((item, replaceListIndex) => (
        <div key={item.id}>
          <h2 className="text-sm pt-3 opacity-80">{item.label}</h2>
          {item.imageList.map((data, imageListIndex) => (
            <Item
              key={imageListIndex}
              unitId={item.id}
              replaceListIndex={replaceListIndex}
              imageListIndex={imageListIndex}
              data={data}
            />
          ))}
        </div>
      ))}
      <div className="flex justify-between text-[12px] pt-3 font-medium">
        <button className="w-[128px] h-[26px] border-[#fff]/40 border-[1px] rounded-sm text-white" onClick={onCancel}>
          取消
        </button>
        <button
          className={`${
            canConfirm ? 'cursor-pointer' : 'cursor-not-allowed'
          } w-[128px] h-[26px] bg-white rounded-sm text-[#1F2329]`}
          onClick={handleConfirm}
        >
          运行
        </button>
      </div>
    </div>
  );
});

export default UnifiedReplacement;
